/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectReport } from './ProjectReport';
import {
    ProjectReportFromJSON,
    ProjectReportFromJSONTyped,
    ProjectReportToJSON,
    ProjectReportToJSONTyped,
} from './ProjectReport';
import type { ProjectLegacyReport } from './ProjectLegacyReport';
import {
    ProjectLegacyReportFromJSON,
    ProjectLegacyReportFromJSONTyped,
    ProjectLegacyReportToJSON,
    ProjectLegacyReportToJSONTyped,
} from './ProjectLegacyReport';

/**
 * 
 * @export
 * @interface PatchRoleInput
 */
export interface PatchRoleInput {
    /**
     * 
     * @type {string}
     * @memberof PatchRoleInput
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsDailyOverview?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsMainOverview?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsDiscountsAndCoupons?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsMarketingChannelOverview?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectProfile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectOrderStatuses?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectAffiliate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectMailing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectOfflineSpends?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectIntegrations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectBilling?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectUsers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectInvitations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProfitability?: boolean;
    /**
     * 
     * @type {Array<ProjectReport>}
     * @memberof PatchRoleInput
     */
    allowedReports?: Array<ProjectReport> | null;
    /**
     * 
     * @type {Array<ProjectLegacyReport>}
     * @memberof PatchRoleInput
     */
    allowedLegacyReports?: Array<ProjectLegacyReport> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProfitMetrics?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsPurchasePriceMetrics?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchRoleInput
     */
    forbiddenChannels?: Array<string> | null;
}

/**
 * Check if a given object implements the PatchRoleInput interface.
 */
export function instanceOfPatchRoleInput(value: object): value is PatchRoleInput {
    return true;
}

export function PatchRoleInputFromJSON(json: any): PatchRoleInput {
    return PatchRoleInputFromJSONTyped(json, false);
}

export function PatchRoleInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchRoleInput {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'allowsDailyOverview': json['allowsDailyOverview'] == null ? undefined : json['allowsDailyOverview'],
        'allowsMainOverview': json['allowsMainOverview'] == null ? undefined : json['allowsMainOverview'],
        'allowsDiscountsAndCoupons': json['allowsDiscountsAndCoupons'] == null ? undefined : json['allowsDiscountsAndCoupons'],
        'allowsMarketingChannelOverview': json['allowsMarketingChannelOverview'] == null ? undefined : json['allowsMarketingChannelOverview'],
        'allowsProjectProfile': json['allowsProjectProfile'] == null ? undefined : json['allowsProjectProfile'],
        'allowsProjectOrderStatuses': json['allowsProjectOrderStatuses'] == null ? undefined : json['allowsProjectOrderStatuses'],
        'allowsProjectAffiliate': json['allowsProjectAffiliate'] == null ? undefined : json['allowsProjectAffiliate'],
        'allowsProjectMailing': json['allowsProjectMailing'] == null ? undefined : json['allowsProjectMailing'],
        'allowsProjectOfflineSpends': json['allowsProjectOfflineSpends'] == null ? undefined : json['allowsProjectOfflineSpends'],
        'allowsProjectIntegrations': json['allowsProjectIntegrations'] == null ? undefined : json['allowsProjectIntegrations'],
        'allowsProjectBilling': json['allowsProjectBilling'] == null ? undefined : json['allowsProjectBilling'],
        'allowsProjectUsers': json['allowsProjectUsers'] == null ? undefined : json['allowsProjectUsers'],
        'allowsProjectInvitations': json['allowsProjectInvitations'] == null ? undefined : json['allowsProjectInvitations'],
        'allowsProfitability': json['allowsProfitability'] == null ? undefined : json['allowsProfitability'],
        'allowedReports': json['allowedReports'] === undefined ? undefined : json['allowedReports'] === null ? null : ((json['allowedReports'] as Array<any>).map(ProjectReportFromJSON)),
        'allowedLegacyReports': json['allowedLegacyReports'] === undefined ? undefined : json['allowedLegacyReports'] === null ? null : ((json['allowedLegacyReports'] as Array<any>).map(ProjectLegacyReportFromJSON)),
        'allowsProfitMetrics': json['allowsProfitMetrics'] === undefined ? undefined : json['allowsProfitMetrics'] === null ? null : json['allowsProfitMetrics'],
        'allowsPurchasePriceMetrics': json['allowsPurchasePriceMetrics'] === undefined ? undefined : json['allowsPurchasePriceMetrics'] === null ? null : json['allowsPurchasePriceMetrics'],
        'forbiddenChannels': json['forbiddenChannels'] === undefined ? undefined : json['forbiddenChannels'] === null ? null : json['forbiddenChannels'],
    };
}

export function PatchRoleInputToJSON(json: any): PatchRoleInput {
    return PatchRoleInputToJSONTyped(json, false);
}

export function PatchRoleInputToJSONTyped(value?: PatchRoleInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'allowsDailyOverview': value['allowsDailyOverview'],
        'allowsMainOverview': value['allowsMainOverview'],
        'allowsDiscountsAndCoupons': value['allowsDiscountsAndCoupons'],
        'allowsMarketingChannelOverview': value['allowsMarketingChannelOverview'],
        'allowsProjectProfile': value['allowsProjectProfile'],
        'allowsProjectOrderStatuses': value['allowsProjectOrderStatuses'],
        'allowsProjectAffiliate': value['allowsProjectAffiliate'],
        'allowsProjectMailing': value['allowsProjectMailing'],
        'allowsProjectOfflineSpends': value['allowsProjectOfflineSpends'],
        'allowsProjectIntegrations': value['allowsProjectIntegrations'],
        'allowsProjectBilling': value['allowsProjectBilling'],
        'allowsProjectUsers': value['allowsProjectUsers'],
        'allowsProjectInvitations': value['allowsProjectInvitations'],
        'allowsProfitability': value['allowsProfitability'],
        'allowedReports': value['allowedReports'] == null ? undefined : ((value['allowedReports'] as Array<any>).map(ProjectReportToJSON)),
        'allowedLegacyReports': value['allowedLegacyReports'] == null ? undefined : ((value['allowedLegacyReports'] as Array<any>).map(ProjectLegacyReportToJSON)),
        'allowsProfitMetrics': value['allowsProfitMetrics'],
        'allowsPurchasePriceMetrics': value['allowsPurchasePriceMetrics'],
        'forbiddenChannels': value['forbiddenChannels'],
    };
}

